/* Source-scoped functional operations for the 23 technical skills. */
export type SkillOperation={value:string;label:string;example:Record<string,unknown>};
export const technicalSkillOperations:Record<string,SkillOperation[]>={
  "github:anthropics/skills:canvas-design": [
    {
      "value": "canvas_generate",
      "label": "Generate SVG and printable design",
      "example": {
        "title": "SAMPLE DESIGN",
        "subtitle": "POSTER CONCEPT",
        "primary": "#087E98",
        "accent": "#B8E6E9"
      }
    }
  ],
  "github:anthropics/knowledge-work-plugins:account-research": [
    {
      "value": "company_search_live",
      "label": "Search public company information",
      "example": {
        "query": "Microsoft"
      }
    },
    {
      "value": "company_save",
      "label": "Save company research",
      "example": {
        "label": "Example company",
        "name": "Example company",
        "industry": "Technology",
        "sourceUrl": "https://example.com"
      }
    },
    {
      "value": "company_research",
      "label": "Search saved company records",
      "example": {
        "query": "technology"
      }
    }
  ],
  "github:anthropics/knowledge-work-plugins:competitive-brief": [
    {
      "value": "seo_html_live",
      "label": "Audit a competitor's public website without API credits",
      "example": {
        "url": "https://example.com"
      }
    },
    {
      "value": "competitor_research",
      "label": "Compare saved competitors",
      "example": {
        "records": [
          {
            "id": "c1",
            "name": "Example A",
            "price": 40,
            "features": [
              "Support",
              "Fast shipping"
            ],
            "sourceUrl": "https://example.com"
          }
        ]
      }
    },
    {
      "value": "competitor_site_audit",
      "label": "Run public competitor website audit",
      "example": {
        "url": "https://example.com"
      }
    },
    {
      "value": "competitor_save",
      "label": "Save competitor",
      "example": {
        "label": "Example A",
        "name": "Example A",
        "price": 40,
        "features": [
          "Support"
        ]
      }
    }
  ],
  "github:anthropics/knowledge-work-plugins:customer-research": [
    {
      "value": "customer_research",
      "label": "Research saved customer evidence",
      "example": {
        "query": "delivery"
      }
    },
    {
      "value": "customer_save",
      "label": "Save customer evidence",
      "example": {
        "label": "Case 1001",
        "text": "Customer reported slow delivery",
        "sourceUrl": "https://example.com"
      }
    }
  ],
  "github:anthropics/knowledge-work-plugins:analyze": [
    {
      "value": "data_analysis",
      "label": "Analyze a real dataset",
      "example": {
        "rows": [
          {
            "segment": "A",
            "revenue": 100,
            "cost": 50
          },
          {
            "segment": "B",
            "revenue": 200,
            "cost": 75
          }
        ],
        "measure": "revenue",
        "groupBy": "segment",
        "compareWith": "cost"
      }
    },
    {
      "value": "analyze_saved",
      "label": "Analyze saved data",
      "example": {
        "recordType": "document",
        "measure": "amount"
      }
    }
  ],
  "github:anthropics/knowledge-work-plugins:deal-review": [
    {
      "value": "deal_review",
      "label": "Review deal risk",
      "example": {
        "records": [
          {
            "id": "d1",
            "amount": 5000,
            "probability": 0.6,
            "daysInStage": 50,
            "nextStep": "",
            "riskFlags": []
          }
        ]
      }
    },
    {
      "value": "deal_save",
      "label": "Save deal to pipeline",
      "example": {
        "label": "Example Deal",
        "id": "d1",
        "stage": "qualified",
        "amount": 5000,
        "probability": 0.6,
        "daysInStage": 10,
        "nextStep": "Contact buyer"
      }
    }
  ],
  "github:anthropics/knowledge-work-plugins:search": [
    {
      "value": "find_information",
      "label": "Search saved documents",
      "example": {
        "query": "launch"
      }
    },
    {
      "value": "github_public_search",
      "label": "Search public GitHub",
      "example": {
        "query": "open source react"
      }
    },
    {
      "value": "save_document",
      "label": "Save searchable document",
      "example": {
        "label": "Launch notes",
        "text": "Example launch briefing",
        "sourceUrl": "https://example.com"
      }
    }
  ],
  "github:tradermonty/claude-trading-skills:trader-memory-core": [
    {
      "value": "thesis_save",
      "label": "Save research thesis",
      "example": {
        "label": "Example Thesis",
        "status": "idea",
        "symbol": "DEMO",
        "hypothesis": "Example only",
        "sourceUrl": "https://example.com"
      }
    },
    {
      "value": "thesis_list",
      "label": "Read journal",
      "example": {}
    },
    {
      "value": "thesis_report",
      "label": "Analyze journal",
      "example": {}
    },
    {
      "value": "thesis_close",
      "label": "Close research thesis",
      "example": {
        "id": "ENTER_EXISTING_UUID",
        "notes": "Reason for closing"
      }
    }
  ],
  "github:tradermonty/claude-trading-skills:market-breadth-analyzer": [
    {
      "value": "market_health_live",
      "label": "Analyze live public breadth CSV",
      "example": {}
    }
  ],
  "github:okx/agent-skills:okx-cex-market": [
    {
      "value": "market_ticker",
      "label": "Live instrument ticker",
      "example": {
        "instId": "BTC-USDT"
      }
    },
    {
      "value": "market_candles",
      "label": "Live OHLCV candles",
      "example": {
        "instId": "BTC-USDT"
      }
    },
    {
      "value": "market_orderbook",
      "label": "Live order book",
      "example": {
        "instId": "BTC-USDT"
      }
    },
    {
      "value": "market_trades",
      "label": "Recent public trades",
      "example": {
        "instId": "BTC-USDT"
      }
    },
    {
      "value": "market_funding",
      "label": "Public funding rate",
      "example": {
        "instId": "BTC-USDT-SWAP"
      }
    },
    {
      "value": "market_open_interest",
      "label": "Public open interest",
      "example": {
        "instId": "BTC-USDT-SWAP"
      }
    }
  ],
  "github:tradermonty/claude-trading-skills:signal-postmortem": [
    {
      "value": "signal_save",
      "label": "Save research signal",
      "example": {
        "label": "Example Signal",
        "id": "signal1",
        "expectedDirection": "up",
        "realizedReturn": 0.05,
        "regime": "neutral"
      }
    },
    {
      "value": "signal_review",
      "label": "Analyze signal performance",
      "example": {}
    },
    {
      "value": "signal_history",
      "label": "Read saved signal journal",
      "example": {}
    }
  ],
  "github:tradermonty/claude-trading-skills:uptrend-analyzer": [
    {
      "value": "market_uptrend_live",
      "label": "Analyze live uptrend CSV",
      "example": {}
    }
  ],
  "github:anthropics/skills:mcp-builder": [
    {
      "value": "mcp_generate",
      "label": "Generate MCP server source files",
      "example": {
        "name": "research-tools",
        "tools": [
          {
            "name": "get_status",
            "description": "Read current status"
          }
        ]
      }
    }
  ],
  "github:anthropics/knowledge-work-plugins:digest": [
    {
      "value": "digest_live",
      "label": "Summarize actual workforce activity",
      "example": {
        "days": 7
      }
    },
    {
      "value": "digest_saved",
      "label": "Summarize saved event records",
      "example": {
        "days": 7
      }
    }
  ],
  "github:anthropics/knowledge-work-plugins:pipeline-review": [
    {
      "value": "pipeline_review",
      "label": "Analyze CRM pipeline data",
      "example": {
        "records": [
          {
            "id": "d1",
            "stage": "proposal",
            "amount": 5000,
            "probability": 0.6,
            "daysInStage": 25
          }
        ]
      }
    },
    {
      "value": "pipeline_saved",
      "label": "Analyze saved deals",
      "example": {}
    }
  ],
  "github:anthropics/knowledge-work-plugins:seo-audit": [
    {
      "value": "seo_html_live",
      "label": "Live on-page SEO and metadata audit",
      "example": {
        "url": "https://retrordinary.com"
      }
    },
    {
      "value": "seo_live",
      "label": "Run live website performance and SEO audit",
      "example": {
        "url": "https://retrordinary.com"
      }
    },
    {
      "value": "seo_html_static",
      "label": "Analyze HTML accessibility and basics",
      "example": {
        "html": "<html lang=\"en\"><title>Example</title><h1>Welcome</h1></html>"
      }
    }
  ],
  "github:anthropics/skills:skill-creator": [
    {
      "value": "skill_generate",
      "label": "Generate installable skill package",
      "example": {
        "name": "research-evaluator",
        "description": "Evaluate referenced data and cite sources",
        "instructions": "Read the given authorized input, check provenance and permissions, produce a grounded report with citations and no side effects."
      }
    }
  ],
  "github:anthropics/knowledge-work-plugins:source-management": [
    {
      "value": "source_list",
      "label": "List recorded source connections",
      "example": {}
    },
    {
      "value": "source_save",
      "label": "Add or prioritize authorized source",
      "example": {
        "label": "Project notes",
        "type": "document",
        "connected": true,
        "priority": 90
      }
    },
    {
      "value": "source_remove",
      "label": "Remove saved source",
      "example": {
        "id": "ENTER_EXISTING_UUID"
      }
    }
  ],
  "github:lumifyai/sports-intelligence-skills:lumify-odds": [
    {
      "value": "sports_odds_live",
      "label": "Get public sports games and published lines",
      "example": {
        "league": "nba"
      }
    }
  ],
  "github:shiqkuangsan/wordcup-space:betting": [
    {
      "value": "convert_odds",
      "label": "Convert odds",
      "example": {
        "odds": -150,
        "format": "american"
      }
    },
    {
      "value": "devig",
      "label": "Remove margin from odds",
      "example": {
        "odds": [
          -110,
          -110
        ],
        "format": "american"
      }
    },
    {
      "value": "find_edge",
      "label": "Calculate expected value",
      "example": {
        "fairProbability": 0.58,
        "marketProbability": 0.52
      }
    },
    {
      "value": "kelly_criterion",
      "label": "Calculate Kelly fraction",
      "example": {
        "fairProbability": 0.58,
        "marketProbability": 0.52
      }
    },
    {
      "value": "find_arbitrage",
      "label": "Exhaustive arbitrage evaluation",
      "example": {
        "marketProbs": [
          0.48,
          0.49
        ]
      }
    },
    {
      "value": "parlay_analysis",
      "label": "Parlay probability and EV",
      "example": {
        "legs": [
          0.58,
          0.62,
          0.55
        ],
        "parlayOdds": 600
      }
    },
    {
      "value": "line_movement",
      "label": "Analyze odds movement",
      "example": {
        "openOdds": -140,
        "closeOdds": -160
      }
    },
    {
      "value": "hedge_matrix",
      "label": "Analyze complete state-matrix hedge",
      "example": {
        "states": [
          {
            "id": "home"
          },
          {
            "id": "away"
          }
        ],
        "tickets": [
          {
            "stake": 50,
            "decimalOdds": 3,
            "winningStates": [
              "home"
            ]
          }
        ],
        "newBets": [
          {
            "stake": 50,
            "decimalOdds": 3,
            "winningStates": [
              "away"
            ]
          }
        ]
      }
    }
  ],
  "github:anthropics/knowledge-work-plugins:task-management": [
    {
      "value": "task_list",
      "label": "List workspace skill tasks",
      "example": {}
    },
    {
      "value": "task_add",
      "label": "Add tracked task",
      "example": {
        "label": "Review site",
        "priority": 80,
        "status": "open",
        "dueDate": "2026-10-30"
      }
    },
    {
      "value": "task_update",
      "label": "Update task fields",
      "example": {
        "id": "ENTER_EXISTING_UUID",
        "changes": {
          "status": "working"
        }
      }
    },
    {
      "value": "task_complete",
      "label": "Mark task completed",
      "example": {
        "id": "ENTER_EXISTING_UUID"
      }
    },
    {
      "value": "task_delete",
      "label": "Delete tracked task",
      "example": {
        "id": "ENTER_EXISTING_UUID"
      }
    }
  ],
  "github:anthropics/skills:web-artifacts-builder": [
    {
      "value": "webapp_generate",
      "label": "Generate working React and Vite files",
      "example": {
        "title": "Ordinary Dashboard",
        "sections": [
          "Overview",
          "Agents",
          "Activity"
        ]
      }
    },
    {
      "value": "artifact_save",
      "label": "Save generated asset files",
      "example": {
        "label": "Example",
        "files": [
          {
            "name": "readme.txt",
            "mediaType": "text/plain",
            "content": "Example asset"
          }
        ]
      }
    },
    {
      "value": "artifact_list",
      "label": "Read saved generated assets",
      "example": {}
    }
  ],
  "github:anthropics/skills:webapp-testing": [
    {
      "value": "seo_html_live",
      "label": "Inspect a live public website's HTML and accessibility basics",
      "example": {
        "url": "https://retrordinary.com"
      }
    },
    {
      "value": "site_lighthouse",
      "label": "Run public site browser audit",
      "example": {
        "url": "https://retrordinary.com"
      }
    },
    {
      "value": "html_static_test",
      "label": "Static HTML accessibility audit",
      "example": {
        "html": "<html lang=\"en\"><title>Example</title><h1>Welcome</h1></html>"
      }
    },
    {
      "value": "playwright_test_generate",
      "label": "Generate actual Playwright test source",
      "example": {
        "url": "https://retrordinary.com"
      }
    }
  ]
};
